import L from 'leaflet';
import { cellToLatLng } from 'h3-js';

export const getPlaceCenter = (place) => {
  if (!place) return null;
  if (place.lat != null && place.lng != null) {
    return [place.lat, place.lng];
  }
  const hexes = place.h3Indexes || place.h3_indexes || [];
  if (hexes.length === 0) return null;
  if (hexes.length === 1) {
    return cellToLatLng(hexes[0]);
  }
  const sample = hexes.slice(0, 15);
  let sumLat = 0, sumLng = 0;
  sample.forEach(hex => {
    const [lat, lng] = cellToLatLng(hex);
    sumLat += lat;
    sumLng += lng;
  });
  return [sumLat / sample.length, sumLng / sample.length];
};

export const createPinIcon = (placeName, showLabel = false, customLabel = null, color = 'red') => {
  const shortName = (placeName || "").split(',')[0].trim();
  const labelText = (customLabel && customLabel.trim()) ? customLabel.trim() : shortName;
  const safeId = (labelText + '_' + color).replace(/[^a-zA-Z0-9]/g, '_');

  const isBlue = color === 'blue';
  const gradStops = isBlue ? `
    <stop offset="0%" stop-color="#bfdbfe"/>
    <stop offset="20%" stop-color="#3b82f6"/>
    <stop offset="60%" stop-color="#1d4ed8"/>
    <stop offset="85%" stop-color="#1e40af"/>
    <stop offset="100%" stop-color="#172554"/>
  ` : `
    <stop offset="0%" stop-color="#ff9999"/>
    <stop offset="20%" stop-color="#ef4444"/>
    <stop offset="60%" stop-color="#b91c1c"/>
    <stop offset="85%" stop-color="#7f1d1d"/>
    <stop offset="100%" stop-color="#450a0a"/>
  `;

  return L.divIcon({
    className: `custom-poster-pin ${showLabel ? 'has-label' : 'no-label'} pin-${color}`,
    html: `
      <div class="physical-pin-wrapper ${showLabel ? 'has-label' : 'no-label'} pin-${color}">
        <div class="physical-pin-graphic">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40" width="40" height="40">
            <defs>
              <filter id="pin-shadow-${safeId}" x="-30%" y="-30%" width="160%" height="160%">
                <feGaussianBlur stdDeviation="1.2" />
              </filter>
              <linearGradient id="needle-grad-${safeId}" x1="0%" y1="0%" x2="100%" y2="100%">
                <stop offset="0%" stop-color="#ffffff"/>
                <stop offset="25%" stop-color="#d4d4d4"/>
                <stop offset="70%" stop-color="#737373"/>
                <stop offset="100%" stop-color="#262626"/>
              </linearGradient>
              <radialGradient id="ball-grad-${safeId}" cx="35%" cy="32%" r="65%">
                ${gradStops}
              </radialGradient>
            </defs>
            <!-- Cast paper shadow of ball and shaft -->
            <ellipse cx="27" cy="25" rx="7.5" ry="3.8" fill="rgba(0,0,0,0.36)" filter="url(#pin-shadow-${safeId})" />
            <polygon points="12,34 27,24 29,26 13,35" fill="rgba(0,0,0,0.26)" filter="url(#pin-shadow-${safeId})" />
            <!-- Puncture hole in the paper -->
            <ellipse cx="12" cy="34" rx="2.2" ry="1.2" fill="rgba(0,0,0,0.7)" />
            <!-- Shiny steel pin shaft -->
            <polygon points="11.4,33.5 12.6,34.5 18.6,17 17.2,16.5" fill="url(#needle-grad-${safeId})" stroke="#1f1f1f" stroke-width="0.3"/>
            <line x1="12" y1="34" x2="17.9" y2="16.8" stroke="#ffffff" stroke-width="0.6" opacity="0.9"/>
            <!-- 3D Spherical Head -->
            <circle cx="19" cy="12" r="8" fill="url(#ball-grad-${safeId})"/>
            <!-- Rim bounce reflection -->
            <path d="M 15 17 A 7.5 7.5 0 0 0 25 14" stroke="rgba(255,255,255,0.4)" stroke-width="0.9" fill="none"/>
            <!-- Specular gloss highlight -->
            <ellipse cx="16" cy="9" rx="2.6" ry="1.6" transform="rotate(-25 16 9)" fill="#ffffff" opacity="0.92"/>
          </svg>
        </div>
        ${showLabel ? `<div class="physical-pin-label pin-label-${color}">${labelText}</div>` : ''}
      </div>
    `,
    iconSize: showLabel ? [40, 56] : [40, 40],
    iconAnchor: [12, 34]
  });
};
